import { SVGProps } from 'react';

export default function CaretDownIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 12, fill = 'currentColor', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path d='M2 4l4 4 4-4' stroke={fill} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
